import GeneralView from '~/generalView';
import Handlebars from 'handlebars';
import linkify from 'linkify';
import linkifystring from 'linkifystring';
import linkifyjquery from 'linkifyjquery';

import EventHub from '~/eventHub';
import news_template from '~/templates/news.handlebars';
import toastr from 'toastr';
import getNewsService from '~/services/newsService';
import PrevisualView from '~/views/previsualView';

/**
 * Category View (show category title and a report ranking of a report)
 * @constructor
 * @type {*}
 */
var NewsView = GeneralView.View.extend({
    tagName: "div",
    className: 'News',
    news: [],
	delObj: null,
	ogFile: null,
	file: null,
	ID: null,
	
    initialize: function () {
		toastr.options = {
			"closeButton": true,
			"debug": false,
			"newestOnTop": true,
			"progressBar": false,
			"positionClass": "toast-top-center",
			"preventDuplicates": false,
			"onclick": null,
			"showDuration": "300",
			"hideDuration": "1000",
			"timeOut": "5000",
			"extendedTimeOut": "1000",
			"showEasing": "swing",
			"hideEasing": "linear",
			"showMethod": "fadeIn",
			"hideMethod": "fadeOut"
		}
	},
	
	events: {
		'click .delete':'removeNews',
		'click .showmore' : 'showNewsInfo',
		'click .btneditnews' : 'showEditNews',
		'change #file' : 'uploadImage',
		'click .discardnews' : 'discardfile',
		'click .btnsavenews' : 'saveEditNews',
		'click .file' : 'previsual',
	},
	
	render: function () {
		var handlebarsTemplate = Handlebars.template(news_template);
		this.$el.html(handlebarsTemplate());
		this.$el.find('.table-responsive').hide();
		this.translate();
		this.attachEvents();
		return this;
	},
	
	attachEvents: function() {
		var that = this;
		getNewsService().fetch({
			all: true,
			cache: false
		}).then((data) => {
			that.news = data.models;
			var options = {
				//weekday: 'long',
				year: 'numeric',
				month: 'short',
				day: 'numeric'
			};
			var langdate = lang + "-GB";
			for (var i = 0; i < data.models.length; i++) {
				data.models[i].creationdate = data.models[i].attributes.createdAt.toLocaleDateString(langdate, options);
				data.models[i].creator = data.models[i].attributes.user.attributes.username;
			}
			var handlebarsTemplate = Handlebars.template(news_template);
			this.$el.html(handlebarsTemplate(data));
			this.translate();
			$('.newsloader').hide();
		},
		(error) => {
			console.log(error);
			switch(error.code){
				case 100:
					toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
				break;
			}
		});
	},
	
	removeNews: function(e){
		this.delObj = $(e.currentTarget).parent().parent();
		var that = this;
		toastr.options.timeOut = "0";
		toastr.options.extendedTimeOut = "0";
		var txt = '<span>'+ arrlang[lang]["DeleteNews"] +'</span><br><button class="btntoastr btnaccept" id="'+ $(e.currentTarget).attr('id') +'">'+ arrlang[lang]["ToastrAccept"] +'</button><button class="btntoastr btncancel">'+ arrlang[lang]["ToastrCancel"] +'</button>';
		this.toastrButtons(txt, 'sucess');
		$('.btnaccept').one("click", function(e){
			that.acceptButtonRemoveNews(e);
		});
		$('.btncancel').one("click", function(){
			that.cancelButtonRemoveNews();
		});
	},
	
	acceptButtonRemoveNews: function(e){
		toastr.options.timeOut = "5000";
		toastr.options.extendedTimeOut = "1000";
		var id = $(e.currentTarget).attr('id');
		for(var i=0; i < this.news.length; ++i){
			if(this.news[i].id == id){
				var xl = function(){
					toastr.success("Noticia Eliminada Correctamente","Operación realizada");
					this.delObj.remove();
				};
				getNewsService().deleteNews(id, xl);
			}
		}
	},
	
	cancelButtonRemoveNews: function(){
		toastr.options.timeOut = "5000";
		toastr.options.extendedTimeOut = "1000";
		toastr.error(arrlang[lang]["NewsNotDeleted"],"");
	},
	
	showNewsInfo: function(e){
		var id = $(e.currentTarget).attr('id').split('show-')[1];
		this.ID = id;
		this.searchNewsInfo(id);
	},
	
	searchNewsInfo: function(id){
		for(var i=0; i < this.news.length; ++i){
			if(this.news[i].id == id){
				$('#newsInfoContainer').empty();
				var content = "<h2 id='NewsTitle'>"+ this.news[i].attributes.title +"</h2>";
				content += "<div id='NewsBody'>"+ this.news[i].attributes.body +"</div>";
				if(this.news[i].attributes.File != null){
					var name = this.news[i].attributes.File._name;
					var title = name.substr(32,name.length-32);
					var url = this.news[i].attributes.File._url;
					content += "<img class='file' src='"+ url +"' alt='' width='100%' height='auto' data-url='"+ url +"' title='"+ title +"' id='NewsFile'>";
				}
				if(this.news[i].attributes.newsLink != ''){
					content += "<center><div class='newsLink' id='NewsLink'> "+ this.news[i].attributes.newsLink +" </div></center>";
				}
				$('#newsInfoContainer').append(content);
				$('.newsLink').linkify();
				$('.linkified').text(arrlang[lang]["NewsAttachedLink"]);
			}
		}
	},
	
	showEditNews: function(e){
		var id = this.ID;
		for(var i=0; i < this.news.length; ++i){
			if(this.news[i].id == id){
				$('#usr').val(this.news[i].attributes.title);
				$('#comment').val(this.news[i].attributes.body);
				$('#file').val('');
				$('.preview-image').attr('src', '');
				$('.discardicon').remove();
				$('.preview-image').hide();
				$('#file_info').hide();
				this.ogFile = null;
				this.file = null;
				if(this.news[i].attributes.File != null){
					var url = this.news[i].attributes.File._url;
					this.ogFile = url;
					this.file = url;
					$('.preview-image').attr('src', url);
					$('#file_info').show();
					$('.preview-image').show();
					$('#file_info').append("<div class='action remove-report discardicon' '  title='Descartar archivo'> <i class='fa fa-trash discardnews'></i></div><br>");
					$(".discardnews").hover(function(){
						$(this).css("color", "#2F4F4F ");
						$(this).css("cursor", "pointer");
					},
					function(){
						$(this).css("color", "inherit");
					});
				}
				$('#url').val('');
				if(this.news[i].attributes.newsLink != ''){
					$('#url').val(this.news[i].attributes.newsLink);
				}
			}
		}
		$('.modal').on('hidden.bs.modal', function (e) {
			if($('.modal').hasClass('in')) {
				$('body').addClass('modal-open');
			}   
		});
	},
	
	uploadImage: function (e) {
		var fullPath = $('#file').val();
		var file = $('#file')[0];
		var temp = fullPath.split('\\');
		var that = this;
		var reader = new FileReader();
		var namelenght = e.target.files[0].name.length;
		this.filescont++;
		var extension = e.target.files[0].name.substring(namelenght-4, namelenght);
		if (extension.charAt(0) != '.'){
			var extension = e.target.files[0].name.substring(namelenght-5, namelenght);
		}
		var name = 'FileNews_'+this.filescont+extension;
		$('.preview-image').attr('src',window.URL.createObjectURL(file.files[0]));
		$('#file_info').show();
		$('.preview-image').show();
		$('.discardicon').remove();
		$('#file_info').append("<div class='action remove-report discardicon' '  title='Descartar archivo'> <i class='fa fa-trash discardnews'></i></div><br>");
		$(".discardnews").hover(function(){
			$(this).css("color", "#2F4F4F ");
			$(this).css("cursor", "pointer");
		},
		function(){
			$(this).css("color", "inherit");
		});
		reader.onload = function (e) {
			var output = that.getFileStream(e.target.result);
			that.file = new Parse.File(name, output);
		};
		reader.readAsArrayBuffer(e.target.files[0]);
	},
	
	getFileStream: function(file){
		var byteArray = new Uint8Array(file);
		var output = new Array(byteArray.length);
		var i = 0;
		var n = output.length;
		while (i < n) {
			output[i] = byteArray[i];
			i++;
		}
		return output;
	},
	
	discardfile: function(e){
		e.currentTarget.parentElement.remove();
		$('#file').val('');
		$('.preview-image').attr('src', '');
		$('.preview-image').hide();
		$('#file_info').hide();
		this.file = null;
	},
	
	saveEditNews: function(){
		var tittle = $('#usr').val();
		var content = $('#comment').val();
		var url = $('#url').val();
		var check;
		if (tittle && content) {
			check = true;
		}
		else{
			check= false;
		}
		if (check ==true) {
			var that = this;
			toastr.options.timeOut = "0";
			toastr.options.extendedTimeOut = "0";
			var txt = '<span>'+ arrlang[lang]["SaveEditNewsbtn"] +'</span><br><button class="btntoastr btnaccept">'+ arrlang[lang]["ToastrAccept"] +'</button><button class="btntoastr btncancel">'+ arrlang[lang]["ToastrCancel"] +'</button>';
			this.toastrButtons(txt, 'sucess');
			$('.btnaccept').one("click", function(e){
				that.acceptButtonSaveEditNews(e);
			});
			$('.btncancel').one("click", function(){
				that.cancelButtonSaveEditNews();
			});
		}
		else{
			toastr.error(arrlang[lang]["Errorpushnot"],"Error");
		}
	},
	
	acceptButtonSaveEditNews: function(e){
		toastr.options.timeOut = "5000";
		toastr.options.extendedTimeOut = "1000";
		var tittle = $('#usr').val();
		var content = $('#comment').val();
		var url = $('#url').val();
		var changeFile = this.file != this.ogFile;
		var that = this;
		var xl = function(updatedNews){
			$('#usr').val('');
			$('#comment').val('');
			$('#url').val('');
			$('#file').val('');
			$('.preview-image').attr('src', '');
			$('.discardicon').remove();
			$('.preview-image').hide();
			$('#file_info').hide();
			that.file = null;
			$('.modal-backdrop.fade.in').remove();
			that.render();
			toastr.success(arrlang[lang]["confirmsendpushnotmessage"],"Operación realizada");
		};
		getNewsService().updateNews(this.ID, tittle, content, url, this.file, changeFile, xl);
	},
	
	cancelButtonSaveEditNews: function(){
		toastr.options.timeOut = "5000";
		toastr.options.extendedTimeOut = "1000";
	},
	
	previsual: function (e){
		var preview = new PrevisualView({file: e.currentTarget.getAttribute("data-url"), title: e.currentTarget.title});
		this.$el.find('#preview').empty();
		this.$el.find('#preview').append(preview.el);
		preview.render();
	},
});
/**
 *
 * Module profileView
 * @module views/profileView
 * @returns ParseService
 */
export default NewsView;
